import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'auto-advanced-page-configuration',
    templateUrl: './page-configuration.component.html',
    styleUrls: ['./page-configuration.component.scss'],
    standalone: false
})
export class AdvancedPageConfigurationComponent implements OnInit, OnChanges {
  @Input() data: any | null = null;
  @Output() dataEmitter = new EventEmitter<UntypedFormGroup>();
  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      whyBuyMessage: [''],
      serviceWhyBuyMessage: [''],
      dealerLicenseName: [''],
      ardNumber: [''],
      servicePhoneNumber: [''],
      serviceDisclosure: [''],
      newFormMainCtaName: [''],
      usedFormMainCtaName: [''],
      pagesMainCtaText: ['', Validators.required],
      inventoryMainCtaText: ['', Validators.required],
      newVlpShowUsed: [false],
      showDefaultForm: [false]
    });

    this.dataEmitter.emit(this.form);
    this.patchFromInput(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.patchFromInput(changes['data'].currentValue);
    }
  }

  private patchFromInput(pageConfigAdvancedSettings: any): void {
    const hasFormAndInput = !!pageConfigAdvancedSettings && !!this.form;

    if (hasFormAndInput) {
      this.form.patchValue({
        whyBuyMessage: pageConfigAdvancedSettings.newUsedWhyBuyMessage || '',
        serviceWhyBuyMessage: pageConfigAdvancedSettings.serviceWhyBuyMessage || '',
        dealerLicenseName: pageConfigAdvancedSettings.dealerLicenseName || '',
        ardNumber: pageConfigAdvancedSettings.ardNumber || '',
        servicePhoneNumber: pageConfigAdvancedSettings.servicePhoneNumber || '',
        serviceDisclosure: pageConfigAdvancedSettings.serviceDisclosure || '',
        newFormMainCtaName: pageConfigAdvancedSettings.newFormMainCtaText || '',
        usedFormMainCtaName: pageConfigAdvancedSettings.usedFormMainCtaText || '',
        pagesMainCtaText: pageConfigAdvancedSettings.pageHeaderMainCtaText || '',
        inventoryMainCtaText: pageConfigAdvancedSettings.headerMainCtaText || '',
        newVlpShowUsed: !!pageConfigAdvancedSettings.showUsedOnNewVlps,
        showDefaultForm: !!pageConfigAdvancedSettings.showFormWhenNoOfferSetsAvailable,
      }, {emitEvent: false});

      this.form.markAsPristine();
    }
  }
}
